// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"574":"e19d6a28","687":"a643d1e4"}[chunkId] + ".chunk.js";
};